import { Navigate, useLocation, useNavigate } from "react-router-dom";
import CustomTitle from "../../commons/generic/CustomTitle";
import { IBlog } from "../../types/CommonTypes";
import {
	Backdrop,
	CircularProgress,
	Typography,
	Box,
	AppBar,
	Toolbar,
	IconButton,
	Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HtmlDescription from "./HtmlDescription";
import useBlog from "../../commons/hooks/useBlog";
import { useEffect } from "react";
import BlogCard from "./BlogCard";
import Footer from "../footer/Footer";
import useWebsite from "../../services/useWebsite";
import { lightBlue } from "../../commons/constants/colors";
import { isMobile } from "react-device-detect";

interface LocationState {
	blog: IBlog;
}

export default function BlogPreview() {
	const location = useLocation();
	const navigate = useNavigate();
	// Solo se llega aquí desde el dashboard, que pasa el blog por state.
	const blog = (location.state as LocationState | null)?.blog;
	const { loading, blogs, retrieveBlogs } = useBlog({});
	const { website } = useWebsite();

	useEffect(() => {
		retrieveBlogs(3);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!blog) return <Navigate to="/" replace />;

	if (loading || !website)
		return (
			<Backdrop open={true}>
				<CircularProgress color="primary" />
			</Backdrop>
		);

	// Filtra el blog actual para que no se muestre en la parte sticky
	const filteredBlogs = blogs.filter((b) => b.slug !== blog.slug);

	return (
		<Box>
			<AppBar position="static" sx={{ backgroundColor: lightBlue }}>
				<Toolbar>
					<IconButton
						edge="start"
						color="primary"
						onClick={() => navigate(-1)}
					>
						<ArrowBackIcon />
					</IconButton>
					<Typography
						variant="h6"
						sx={{ flexGrow: 1, color: "white" }}
					>
						Volver
					</Typography>
				</Toolbar>
			</AppBar>

			<Stack
				direction={"row"}
				justifyContent={"space-around"}
				sx={{ padding: 3 }}
			>
				<Box
					sx={{
						maxWidth: "800px",
					}}
				>
					<CustomTitle>{blog.title}</CustomTitle>

					{blog.date && (
						<Typography
							variant="subtitle2"
							color="textSecondary"
							textAlign={"center"}
							sx={{ marginBottom: 2 }}
						>
							{new Date(blog.date).toLocaleDateString()}
						</Typography>
					)}

					{blog.picture?.url && (
						<Box sx={{ marginBottom: 3 }}>
							<img
								src={blog.picture.url}
								alt={blog.title || "Imagen del blog"}
								style={{
									width: "100%",
									height: "auto",
									borderRadius: "8px",
								}}
							/>
						</Box>
					)}

					<HtmlDescription htmlContent={blog.description || ""} />
				</Box>

				{!isMobile && filteredBlogs.length > 0 && (
					<Box
						sx={{
							position: "sticky",
							top: 80,
							alignSelf: "flex-start",
							width: "20%",
						}}
					>
						<CustomTitle
							fontWeight={300}
							variant={"body2"}
							fontSize="1.5rem"
							letterSpacing="0.06em"
						>
							Tambien te puede interesar
						</CustomTitle>
						<BlogCard
							blog={
								filteredBlogs[
									Math.floor(
										Math.random() * filteredBlogs.length
									)
								]
							}
						/>
					</Box>
				)}
			</Stack>
			<Footer item={website.footer} />
		</Box>
	);
}
